import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { select } from "async";

export interface AppInfo {
    key: string;
    data: any;
}
interface UserWebLayoutState {
    appInfos: any;
    selectedAppId: string;
}

const initialState: UserWebLayoutState = {
    appInfos: {},
    selectedAppId: '',
};

const userWebLayoutSlice = createSlice({
    name: 'userWebLayout',
    initialState,
    reducers: {
        addAppInfo(state, action: PayloadAction<string>) {
            state.appInfos[action.payload] = { };
        },
        removeAppInfo(state, action: PayloadAction<string>) {
            state.appInfos[action.payload] = undefined;
        },
        updateAppInfo(state, action: PayloadAction<AppInfo>) {
            state.appInfos[action.payload.key] = action.payload.data;
        },
        selectApp(state, action: PayloadAction<string>) {
            state.selectedAppId = action.payload;
        },
    },
});

export const { 
    addAppInfo, 
    removeAppInfo,
    updateAppInfo,
    selectApp
} = userWebLayoutSlice.actions;

export default userWebLayoutSlice.reducer;
